export default __webpack_public_path__ + "static/media/975.14704f3b.gif";